import _objectSpread from "/opt/render/project/src/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "/opt/render/project/src/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.string.trim.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withKeys as _withKeys, toDisplayString as _toDisplayString, Fragment as _Fragment, createElementBlock as _createElementBlock, createSlots as _createSlots, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-64a28cce"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "content-shape container pt-4 flex-fill"
};
var _hoisted_2 = {
  class: "d-flex flex-column align-items-center text-center"
};

var _hoisted_3 = /*#__PURE__*/_createTextVNode("Password reset");

var _hoisted_4 = /*#__PURE__*/_createTextVNode(" Update password ");

var _hoisted_5 = /*#__PURE__*/_createTextVNode("Go to Home");

var _hoisted_6 = {
  class: "text-center"
};

var _hoisted_7 = /*#__PURE__*/_createTextVNode(" This link could not be validated. If you are trying to reset your password, please follow ");

var _hoisted_8 = /*#__PURE__*/_createTextVNode("click here");

var _hoisted_9 = /*#__PURE__*/_createTextVNode(". ");

var _hoisted_10 = /*#__PURE__*/_createTextVNode("Try again");

import { ref, reactive } from "vue";
import { useRoute } from "vue-router";
import { useLoadingBar } from "naive-ui";
import { useUserStore } from "@/store/user";
import { LoaderState as LoaderStateEnum } from "@/types/generic";
import { UserValidator } from "@/schemes/user";
import { getErrorMessage, handleError } from "@/utils/errors";
import Link from "@/components/utils/Link.vue";
import http from "@/http";
export default /*#__PURE__*/_defineComponent({
  setup: function setup(__props) {
    var route = useRoute();
    var userStore = useUserStore();
    var loadingBar = useLoadingBar();
    var LoaderState = LoaderStateEnum;
    var loaders = reactive({
      verify: LoaderStateEnum.Loading,
      reset: LoaderStateEnum.Idle
    });
    var errors = reactive({});
    var invalidMessage = ref("");
    var invalid = ref(false);
    var model = reactive({
      password: ""
    });
    var rules = {
      password: UserValidator.password
    };
    var form = ref(null);

    if (typeof route.query.t !== "string" || route.query.t.trim().length === 0) {
      invalid.value = true;
      errors.validation = invalidMessage.value;
      loaders.reset = LoaderStateEnum.Failed;
    }

    var verify = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                loadingBar.start();
                loaders.verify = LoaderStateEnum.Loading;
                _context2.prev = 2;
                _context2.next = 5;
                return http.post("auth/recover/verify", {
                  token: route.query.t
                });

              case 5:
                loaders.verify = LoaderStateEnum.Loaded;
                loadingBar.finish();
                _context2.next = 16;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2["catch"](2);
                _context2.next = 13;
                return handleError(_context2.t0, {
                  http: function () {
                    var _http = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(e) {
                      var _e$response, _e$response2, _e$response2$data;

                      return regeneratorRuntime.wrap(function _callee$(_context) {
                        while (1) {
                          switch (_context.prev = _context.next) {
                            case 0:
                              invalid.value = ((_e$response = e.response) === null || _e$response === void 0 ? void 0 : _e$response.status) === 400;
                              return _context.abrupt("return", invalid.value ? invalidMessage.value : getErrorMessage((_e$response2 = e.response) === null || _e$response2 === void 0 ? void 0 : (_e$response2$data = _e$response2.data) === null || _e$response2$data === void 0 ? void 0 : _e$response2$data.errors));

                            case 2:
                            case "end":
                              return _context.stop();
                          }
                        }
                      }, _callee);
                    }));

                    function http(_x) {
                      return _http.apply(this, arguments);
                    }

                    return http;
                  }()
                });

              case 13:
                errors.verify = _context2.sent;
                loaders.verify = LoaderStateEnum.Failed;
                loadingBar.error();

              case 16:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[2, 9]]);
      }));

      return function verify() {
        return _ref.apply(this, arguments);
      };
    }();

    var submit = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (form.value) {
                  _context4.next = 2;
                  break;
                }

                return _context4.abrupt("return");

              case 2:
                _context4.prev = 2;
                _context4.next = 5;
                return form.value.validate();

              case 5:
                _context4.next = 10;
                break;

              case 7:
                _context4.prev = 7;
                _context4.t0 = _context4["catch"](2);
                return _context4.abrupt("return", false);

              case 10:
                loaders.reset = LoaderStateEnum.Loading;
                _context4.prev = 11;
                _context4.next = 14;
                return userStore.reset(_objectSpread({
                  token: route.query.t
                }, model));

              case 14:
                loaders.reset = LoaderStateEnum.Loaded;
                _context4.next = 23;
                break;

              case 17:
                _context4.prev = 17;
                _context4.t1 = _context4["catch"](11);
                _context4.next = 21;
                return handleError(_context4.t1, {
                  http: function () {
                    var _http2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(e) {
                      var _e$response3, _e$response4, _e$response4$data;

                      return regeneratorRuntime.wrap(function _callee3$(_context3) {
                        while (1) {
                          switch (_context3.prev = _context3.next) {
                            case 0:
                              return _context3.abrupt("return", (e === null || e === void 0 ? void 0 : (_e$response3 = e.response) === null || _e$response3 === void 0 ? void 0 : _e$response3.status) === 400 ? "Sorry, this link is no longer valid." : getErrorMessage((_e$response4 = e.response) === null || _e$response4 === void 0 ? void 0 : (_e$response4$data = _e$response4.data) === null || _e$response4$data === void 0 ? void 0 : _e$response4$data.errors));

                            case 1:
                            case "end":
                              return _context3.stop();
                          }
                        }
                      }, _callee3);
                    }));

                    function http(_x2) {
                      return _http2.apply(this, arguments);
                    }

                    return http;
                  }()
                });

              case 21:
                errors.reset = _context4.sent;
                loaders.reset = LoaderStateEnum.Failed;

              case 23:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, null, [[2, 7], [11, 17]]);
      }));

      return function submit() {
        return _ref2.apply(this, arguments);
      };
    }();

    verify();
    return function (_ctx, _cache) {
      var _component_n_skeleton = _resolveComponent("n-skeleton");

      var _component_n_result = _resolveComponent("n-result");

      var _component_n_h1 = _resolveComponent("n-h1");

      var _component_n_input = _resolveComponent("n-input");

      var _component_n_form_item = _resolveComponent("n-form-item");

      var _component_n_button = _resolveComponent("n-button");

      var _component_n_alert = _resolveComponent("n-alert");

      var _component_n_form = _resolveComponent("n-form");

      var _component_router_link = _resolveComponent("router-link");

      var _component_n_spin = _resolveComponent("n-spin");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_n_spin, {
        size: 76,
        show: _unref(loaders).verify === _unref(LoaderState).Loading
      }, {
        default: _withCtx(function () {
          return [_unref(loaders).verify === _unref(LoaderState).Loading ? (_openBlock(), _createBlock(_component_n_result, {
            key: 0,
            class: "invisible"
          }, {
            icon: _withCtx(function () {
              return [_createVNode(_component_n_skeleton, {
                sharp: false,
                class: "skeleton-item icon d-inline-block"
              })];
            }),
            default: _withCtx(function () {
              return [_createElementVNode("div", _hoisted_2, [_createVNode(_component_n_skeleton, {
                class: "skeleton-item title mb-4"
              }), _createVNode(_component_n_skeleton, {
                class: "skeleton-item message"
              })])];
            }),
            _: 1
          })) : !invalid.value ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 1
          }, [_createVNode(_component_n_h1, null, {
            default: _withCtx(function () {
              return [_hoisted_3];
            }),
            _: 1
          }), _unref(loaders).reset !== _unref(LoaderState).Loaded ? (_openBlock(), _createBlock(_component_n_form, {
            key: 0,
            model: _unref(model),
            ref_key: "form",
            ref: form,
            rules: rules
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_n_form_item, {
                path: "password",
                label: "New password",
                size: "large"
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_n_input, {
                    value: _unref(model).password,
                    "onUpdate:value": _cache[0] || (_cache[0] = function ($event) {
                      return _unref(model).password = $event;
                    }),
                    type: "password",
                    "show-password-on": "click",
                    onKeydown: _withKeys(submit, ["enter"])
                  }, null, 8, ["value", "onKeydown"])];
                }),
                _: 1
              }), _createElementVNode("div", null, [_createVNode(_component_n_button, {
                type: "primary",
                loading: _unref(loaders).reset === _unref(LoaderState).Loading,
                onClick: submit
              }, {
                default: _withCtx(function () {
                  return [_hoisted_4];
                }),
                _: 1
              }, 8, ["loading"])]), _unref(loaders).reset === _unref(LoaderState).Failed ? (_openBlock(), _createBlock(_component_n_alert, {
                key: 0,
                type: "error",
                class: "white-space-pre-line mt-3",
                "show-icon": false
              }, {
                default: _withCtx(function () {
                  return [_createTextVNode(_toDisplayString(_unref(errors).reset), 1)];
                }),
                _: 1
              })) : _createCommentVNode("", true)];
            }),
            _: 1
          }, 8, ["model"])) : (_openBlock(), _createBlock(_component_n_result, {
            key: 1,
            status: "success",
            title: "Password updated",
            description: "Your password has been updated, you can sign in with this one from now."
          }, {
            footer: _withCtx(function () {
              return [_createVNode(_component_router_link, {
                to: {
                  name: 'Home'
                },
                class: "text-decoration-none"
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_n_button, null, {
                    default: _withCtx(function () {
                      return [_hoisted_5];
                    }),
                    _: 1
                  })];
                }),
                _: 1
              })];
            }),
            _: 1
          }))], 64)) : (_openBlock(), _createBlock(_component_n_result, {
            key: 2,
            status: "error",
            title: invalid.value ? 'Invalid link' : 'Error',
            class: "invalid-result"
          }, _createSlots({
            default: _withCtx(function () {
              return [_createElementVNode("div", _hoisted_6, [invalid.value ? (_openBlock(), _createElementBlock(_Fragment, {
                key: 0
              }, [_hoisted_7, _createVNode(Link, {
                to: {
                  name: 'AccountRecovery'
                }
              }, {
                default: _withCtx(function () {
                  return [_hoisted_8];
                }),
                _: 1
              }), _hoisted_9], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
                key: 1
              }, [_createTextVNode(_toDisplayString(_unref(errors).verify), 1)], 64))])];
            }),
            _: 2
          }, [!invalid.value ? {
            name: "footer",
            fn: _withCtx(function () {
              return [_createVNode(_component_n_button, {
                onClick: verify
              }, {
                default: _withCtx(function () {
                  return [_hoisted_10];
                }),
                _: 1
              })];
            })
          } : undefined]), 1032, ["title"]))];
        }),
        _: 1
      }, 8, ["show"])]);
    };
  }
});